import React from "react";
import { useTranslation } from "./hooks/useTranslation";
import { StatusLabel } from "./StatusLabel";
import { ColorOptions } from "./types";
export const ObjectiveStatus = ({ results, type, active = false, size, }) => {
    const t = useTranslation();
    const { color, append, text } = contentResultToContentResultLabel(results, type, t, active);
    return React.createElement(StatusLabel, { text: text, color: color, append: append, size: size });
};
export const getScore = (results) => {
    const score = results.scorePercent || results.score;
    return score && `${parseInt(score)}%`;
};
export const contentResultToContentResultLabel = (results, type, t = () => "", active) => {
    if (!results.lastAccessed) {
        return {
            color: ColorOptions.LightGrey,
            append: undefined,
            text: t("Not Accessed"),
        };
    }
    if (["discussion", "external", "kryterion"].includes(type)) {
        if (results.status === "incomplete") {
            return {
                color: ColorOptions.Blue,
                append: undefined,
                text: t("In Progress"),
            };
        }
        if (results.status === "completed") {
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Completed"),
            };
        }
    }
    if (type === "scorm" || type === "video" || type === "quiz") {
        if (results.status === "passed") {
            return {
                color: ColorOptions.Green,
                append: getScore(results),
                text: t("Passed"),
            };
        }
        if (results.status === "failed") {
            return {
                color: ColorOptions.Red,
                append: getScore(results),
                text: t("Failed"),
            };
        }
        if (results.status === "completed") {
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Completed"),
            };
        }
        if (active) {
            if (type === "video") {
                return {
                    color: ColorOptions.Blue,
                    append: results.progress
                        ? `${parseInt(results.progress)}%`
                        : undefined,
                    text: t("Progress"),
                };
            }
            return {
                color: ColorOptions.Blue,
                append: undefined,
                text: t("In Progress"),
            };
        }
        if (results.status === "incomplete") {
            return {
                color: ColorOptions.Blue,
                append: results.progress ? `${parseInt(results.progress)}%` : undefined,
                text: results.progress ? t("Progress") : t("In Progress"),
            };
        }
    }
    switch (results?.status) {
        case "completed":
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Completed"),
            };
        case "downloaded":
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Downloaded"),
            };
        case "incomplete":
            return {
                color: ColorOptions.Blue,
                append: undefined,
                text: t("Incomplete"),
            };
        case "passed":
            return {
                color: ColorOptions.Green,
                append: getScore(results),
                text: t("Passed"),
            };
        case "failed":
            return {
                color: ColorOptions.Red,
                append: getScore(results),
                text: t("Failed"),
            };
        default:
            return {
                color: ColorOptions.LightGrey,
                append: undefined,
                text: "",
            };
    }
};
